export const OWN_PRODUCTS_QUERY = '/products';
export const ORGANISATION_PRODUCTS_QUERY = '/organisations/:organisationID/products';
export const SUPPLIER_ASSOCIATED_PRODUCT_IDS_QUERY = '/suppliers/:supplierID/associated-products';
export const CLIENT_ASSOCIATED_PRODUCT_IDS_QUERY = '/clients/:clientID/associated-products';
